interface RichTextProps {
  /** HTML already sanitised by the API (see App\Support\RichText). */
  html: string;
  className?: string;
}

/**
 * Renders the small rich-text fields written in the dashboard's editor
 * (paragraphs, bold/italic, lists, links) with consistent spacing.
 */
export default function RichText({ html, className = "" }: RichTextProps) {
  return (
    <div
      className={`[&_p]:mb-2 [&_p:last-child]:mb-0 [&_strong]:font-bold [&_b]:font-bold [&_ul]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:mb-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:mb-1 [&_a]:underline [&_a]:underline-offset-2 [&_blockquote]:border-l-2 [&_blockquote]:pl-3 [&_blockquote]:italic ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
